import { useServices } from 'core/common/hooks';

export function useTax() {
  const { taxService } = useServices();

  return {
    tax: taxService.getTax(),
  };
}
